module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "anthony-korner-square.54088408.png" + "?" + Date.now();